import { FaYoutube } from "react-icons/fa6";
import { IoMdArrowBack } from "react-icons/io";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";

function GroupChat() {
  const { uid } = useSelector((state) => state.auth);

  return (
    <>
      <div className="trending">
        <button type="button" className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
          <IoMdArrowBack /> Go Back
        </button>{" "}
        <div className="group-chat-container">
          <div className="single-chat  ">
            <a
              className="text-white btn btn-primary "
              href="https://youtu.be/C5oVmQTSg_w"
              target="_blank"
            >
              <FaYoutube className="youtube-icon" /> Play Video
            </a>
            <a
              className="text-white btn btn-primary mt-2 "
              href={`https://athlete-for-brand.web.app/login?redirect=/group-chat&athleteId=${uid}`}
              target="_blank"
            >
              Go to site
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default GroupChat;
